import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { findDOMNode } from 'react-dom'
import { DragSource, DropTarget } from 'react-dnd'

const source = {
  beginDrag(props) {
    return {
      id: props.id,
      nodeId: props.nodeId,
      items: props.item.children
    }
  },

  isDragging(props, monitor) {
    return props.id == monitor.getItem().id
  },

  endDrag(props, monitor) {
    // if the drop wasn't successful, but the row was moved
    // move it back to its original spot.
    // Requires logging of original location in beginDrag.
    // const {id: droppedId, originalIndex} = monitor.getItem()
    // const didDrop = monitor.didDrop()

    // if (!didDrop) {
    //   props.move(droppedId, originalIndex)
    // }

    props.drop && props.drop()
  }
}

const target = {
  canDrop() {
    return false
  },

  hover(props, monitor, component) {
    const {id: draggedId} = monitor.getItem()
    const {id: overId} = props

    if (draggedId == overId) return
    if (draggedId == props.nodeId) return
    if (!monitor.isOver({shallow: true})) return

    props.move(draggedId, overId, props.nodeId)
  }
}

@DropTarget(props => props.itemType, target, connect => ({
  connectDropTarget: connect.dropTarget()
}))
@DragSource(props => props.itemType, source, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging()
}))
export default class TreeItem extends Component {
  static propTypes = {
    connectDragSource: PropTypes.func.isRequired,
    connectDragPreview: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    itemType: PropTypes.string.isRequired,
    isDragging: PropTypes.bool.isRequired,
    id: PropTypes.any.isRequired,
  };

  render() {
    const {connectDropTarget, children, ...props} = this.props
    return React.cloneElement(React.Children.only(children), {
      ...props,
      ref: instance => {
        connectDropTarget(findDOMNode(instance))
      }
    })
  }
}



// WEBPACK FOOTER //
// ./app/components/TreeItem.js